import React from 'react';

import Home from './components/Home.js';

function App() {
  return (
    <div>
		<Home />
    </div>
  );
}

export default App;
